import {createSelector} from '@ngrx/store';
import VideoState from '../video.state';

export const selectState = (state: { video: VideoState }) => state;

export const selectGenerationStartedTime = createSelector(
    selectState,
    (state: { video: VideoState }) => {
        const meta = state.video.project.meta;

        return new Date(meta.generationStartedAt || meta.updatedAt || Date.now());
    }
);
